import { Form, InputNumber } from 'antd';

interface IntervalFieldsProps {
  /** Shown under the three fields, e.g. what an empty set means on this form. */
  hint?: string;
}

/** The km, days and hours legs of an interval set — all optional here; each form says how many it needs. */
export function IntervalFields({ hint }: IntervalFieldsProps) {
  return (
    <>
      <Form.Item name="intervalKm" label="Every (km)">
        <InputNumber className="w-full" min={1} precision={0} />
      </Form.Item>
      <Form.Item name="intervalDays" label="Every (days)">
        <InputNumber className="w-full" min={1} precision={0} />
      </Form.Item>
      <Form.Item name="intervalHours" label="Every (engine hours)" extra={hint}>
        <InputNumber className="w-full" min={1} precision={0} />
      </Form.Item>
    </>
  );
}
